/** @jsxImportSource theme-ui */
import React from 'react';
import { toast } from 'react-toastify';
import Button from '@/components/Button';
import {
    useEditDiscountAgreementsMutation,
    useLazyGetDiscountAgreementQuery,
} from '@/store/apiService';
import { DiscountAgreementStatusEnum } from '@/types/types';
import { getErrorMessage } from '@/utils/helpers';
import { buildStatusChangePayload } from './discountAgreementStatus';

type Props = {
    agreementId: string;
};

const PublishDiscountAgreementButton: React.FC<Props> = ({ agreementId }) => {
    const [fetchDiscountAgreement, fetchState] = useLazyGetDiscountAgreementQuery();
    const [editDiscountAgreement, editState] = useEditDiscountAgreementsMutation();
    const isPublishing = fetchState.isFetching || editState.isLoading;

    const publishDiscountAgreement = () =>
        fetchDiscountAgreement({ id: agreementId })
            .unwrap()
            .then((agreement) =>
                editDiscountAgreement(
                    buildStatusChangePayload(agreement, DiscountAgreementStatusEnum.Published)
                ).unwrap()
            )
            .then(() => toast.success('Published'))
            .catch((error) => toast.error(getErrorMessage(error)));

    return (
        <Button isLoading={isPublishing} disabled={isPublishing} onClick={publishDiscountAgreement}>
            Publish
        </Button>
    );
};

export default PublishDiscountAgreementButton;
